export default __webpack_public_path__ + "static/media/img-0492-andorra-premium-face.40f804b7.png";